import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Definizione } from '../../shared/interface';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-abbecedario',
  templateUrl: './abbecedario.component.html',
  styleUrl: './abbecedario.component.css',
  encapsulation: ViewEncapsulation.None
})
export class AbbecedarioComponent implements OnInit {

  constructor(private apiService: ApiService) { }

  definizioni: Definizione[] = []
  definizioni_raggruppate: { alfabeto: string, elementi: Definizione[] }[] = []
  definizioni_filtrate: Definizione[] = [];

  ngOnInit(): void {
  
    this.getData();

  }

  getData() {

    this.apiService.getDefinizioni().subscribe({
      next: (data) => this.definizioni = [...data],
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {

        // Primo passo: raggruppare per alfabeto
        const raggruppatoPerAlfabeto = this.definizioni.reduce((acc: any, obj) => {
          const key = obj.alfabeto;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(obj);
          return acc;
        }, {});

        // Secondo passo: convertire l'oggetto raggruppato in un array di oggetti
        this.definizioni_raggruppate = Object.keys(raggruppatoPerAlfabeto).map(key => {
          return {
            alfabeto: key,
            elementi: raggruppatoPerAlfabeto[key]
          };
        });
      }
    })
  }

  onFilterDefinizioni(event: AutoCompleteCompleteEvent) {

    let filtered: Definizione[] = [];
    let query = event.query;

    for (let i = 0; i < (this.definizioni).length; i++) {

      let definizione = (this.definizioni)[i];
      if (definizione.titolo.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(definizione);
      }
    }

    this.definizioni_filtrate = filtered;
  }

  onSelectDefinizione(event: any) {

    let definizioni = [event.value]

    // Primo passo: raggruppare per alfabeto
    const raggruppatoPerAlfabeto = definizioni.reduce((acc: any, obj) => {
      const key = obj.alfabeto;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});

    // Secondo passo: convertire l'oggetto raggruppato in un array di oggetti
    this.definizioni_raggruppate = Object.keys(raggruppatoPerAlfabeto).map(key => {
      return {
        alfabeto: key,
        elementi: raggruppatoPerAlfabeto[key]
      };
    });
  }
}
